//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogShow: false,
      data: []
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.data = data || [];
      this.dialogShow = true;
    }
  }
};